import { ChangeEvent } from "react";
import {
  Input,
  Textarea,
  NativeSelect,
  Stack,
  Box,
  Card,
} from "@chakra-ui/react";
import { t } from "i18next";
import { CraAttribute, CraAttributeType } from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../coding/utils/attribute-utils";

export const AttributeInput = ({
  attribute,
  value,
  setValue,
  allowNullValues = false,
}: {
  attribute: CraAttribute;
  value: any;
  setValue: (value: string | null) => void;
  allowNullValues?: boolean;
}) => {
  switch (attribute.type) {
    case CraAttributeType.Number: {
      return (
        <Input
          type="number"
          value={value || ""}
          autoFocus
          placeholder={t(`coding:spreadsheet.numberPlaceholder`)}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setValue(e.target.value)
          }
        />
      );
    }
    case CraAttributeType.TextArea: {
      return (
        <Textarea
          value={value || ""}
          autoFocus
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setValue(e.target.value)
          }
        />
      );
    }
    case CraAttributeType.Select: {
      if (attribute.useImageSelection) {
        return (
          <Card.Root fontSize={"xs"}>
            <Stack gap={0}>
              {attribute.options.map((option) => (
                <Box
                  p={1}
                  bgColor={
                    option.value === value ? "primary.100" : "transparent"
                  }
                  _hover={{ backgroundColor: "primary.50" }}
                  cursor={"pointer"}
                  key={option.value}
                  onClick={() => {
                    setValue(option.value);
                  }}
                >
                  {CraAttributeUtils.getOptionLabel(option.value)}
                </Box>
              ))}
            </Stack>
          </Card.Root>
        );
      }
      return (
        <NativeSelect.Root>
          <NativeSelect.Field
            value={value || ""}
            placeholder={
              allowNullValues
                ? t(`coding:spreadsheet.selectPlaceholder`)
                : undefined
            }
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              setValue(e.target.value || null)
            }
          >
            {attribute.options.map((option, i) => {
              return (
                <option key={i} value={option.value}>
                  {CraAttributeUtils.getOptionLabel(option.value)}
                </option>
              );
            })}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
      );
    }
  }
};
